// TawkWrapper.tsx
import { useEffect } from "react";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import { useStore } from "@/stores/store.js";
import { useAccessControl } from "@/hooks/useAccessControl";

const ANALYST_PROPERTY_ID = "58707db72438f53b0a2585c1";
const SALES_PROPERTY_ID = "59cccc46c28eca75e4622dc0";

const capitalize = (s = "") =>
  s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

const TawkWrapper = () => {
  const { tokenParsed } = useStore();
  const { hasLiveAccess } = useAccessControl();

  const propertyId = hasLiveAccess ? ANALYST_PROPERTY_ID : SALES_PROPERTY_ID;

  useEffect(() => {
    if (!tokenParsed) return;

    const { given_name, family_name, email } = tokenParsed;
    const first_name = capitalize(given_name);
    const last_name = capitalize(family_name);

    // Bail until the Tawk API is available
    if (!window.Tawk_API) return;

    window.Tawk_API.onLoad = () => {
      const attrs = { name: `${first_name} ${last_name}`, email };

      const trySetAttributes = (attempt) => {
        window.Tawk_API.setAttributes(attrs, (err) => {
          if (err) {
            if (attempt < 2) {
              console.warn(`[Tawk] setAttributes failed (attempt ${attempt}), retrying in 3s...`);
              setTimeout(() => trySetAttributes(attempt + 1), 3000);
            } else {
              console.error("[Tawk] setAttributes failed after retry:", err);
            }
          }
        });
      };

      trySetAttributes(1);
    };
  }, [tokenParsed, propertyId]);

  return (
    <TawkMessengerReact
      key={propertyId}
      propertyId={propertyId}
      widgetId="default"
    />
  );
};

export default TawkWrapper;
